// extracted by mini-css-extract-plugin
module.exports = {"fixed-width":"_-web-client-js-react-components-___WTFPrincipalField-module__fixed-width___1ah31"};